import * as Cordova from './Cordova';
import * as Platform from './Platform';
import addPrecondition from './addPrecondition';
import * as Command from './Command';
import * as LogAppender from './LogAppender';
import Electron from './Electron';

import { invoke } from './BridgeProxy';
import { Endpoints } from './BridgeProxy.Endpoints';

export * from './Settings';
export * from './CardTransactionMetadata';
export * from './beeper';
import * as UserActivityRegistry from './UserActivityRegistry';

const BridgeProxy = { invoke, Endpoints };

export {
	Cordova,
	LogAppender,
	addPrecondition,
	Command,
	Electron,
	BridgeProxy,
	Platform,
	UserActivityRegistry
};
